import CounterNodeGraph from './CounterNodeGraph';
import CounterDecorationNodeGraph from './CounterDecorationNodeGraph';
import UseMemoGraph from './UseMemoGraph';
import DecorativeBoxesNodeGraph from './DecorativeBoxesNodeGraph';
import PrimeClockGraph from './PrimeClockGraph';
import PurePrimeClockGraph from './PurePrimeClockGraph';

const MAP = {
  CounterNodeGraph,
  CounterDecorationNodeGraph,
  UseMemoGraph,
  DecorativeBoxesNodeGraph,
  PrimeClockGraph,
  PurePrimeClockGraph,
};

export default function WhyReactRenders({
  component,
  ...props
}: {
  component: keyof typeof MAP;
}) {
  const Component = MAP[component];

  if (!Component) {
    console.error(component, props);
    throw new Error(
      'Tried rendering a “WhyReactRenders” demo, but no component was found under name: ' +
        component +
        '. See console log for more info'
    );
  }

  return <Component {...props} />;
}
